import { render, staticRenderFns } from "./addType.vue?vue&type=template&id=5d3ee271&scoped=true&"
import script from "./addType.vue?vue&type=script&lang=js&"
export * from "./addType.vue?vue&type=script&lang=js&"
import style0 from "./addType.vue?vue&type=style&index=0&id=5d3ee271&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ee271",
  null
  
)

export default component.exports